import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Project_detail.css";
import Icon from "@mdi/react";
import { mdiAndroid, mdiApple, mdiChevronLeft, mdiWeb } from "@mdi/js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Image } from "react-bootstrap";
import ScrollReveal from "scrollreveal";

const Project_Detail = () => {
  const location = useLocation();
  const { project } = location.state;
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(true);

  useEffect(() => {
    setCurrentImage(project?.images?.[0]);
  }, []);

  useEffect(() => {
    const sr = ScrollReveal({
      distance: "50px",
      duration: 2000,
      delay: 150,
      reset: true,
    });

    sr.reveal(".main-info-view", { origin: "top" });
    sr.reveal(".icon-container", { origin: "bottom" });
    sr.reveal(".left-view", { origin: "left" });
    sr.reveal(".right-view", { origin: "right" });
  }, []);

  useEffect(() => {
    const sr = ScrollReveal({
      distance: "50px",
      duration: 2800,
      delay: 150,
      reset: true,
    });

    sr.reveal(
      ".other-image-container-landscape, .other-image-container-portrait",
      { origin: "bottom" }
    );
    sr.reveal(
      ".current-image-container-landscape, .current-image-container-portrait",
      { origin: "left" }
    );
  }, []);

  return (
    <div className="main-container">
      <div className="left-view">
        <div className="back-btn" onClick={() => navigate(-1)}>
          <Icon path={mdiChevronLeft} className="back-icon" />
        </div>
        <div className="main-info-view">
          {!imageLoaded ? (
            <div
              className="skeleton-loader"
              style={{ height: "220px", width: "100%" }}
            ></div> // Adjust width and height
          ) : (
            <Image
              src={project.mainImage}
              alt="Project Image"
              className="main-image"
              onError={(e) => (e.target.style.display = "none")}
            />
          )}

          <h1>{project.name}</h1>
          <span>{project.description}</span>
          <div className="icon-container">
            <button
              className={`${
                project.android_link ? "icon-btn" : "icon-btn-disable"
              }`}
              onClick={() => window.open(project.android_link, "_blank")}
            >
              <Icon path={mdiAndroid} className="back-icon" />
            </button>
            <button
              className={`${
                project.ios_link ? "icon-btn" : "icon-btn-disable"
              }`}
              onClick={() => window.open(project.ios_link, "_blank")}
            >
              <Icon path={mdiApple} className="back-icon" />
            </button>
            <button
              className={`${
                project.web_link ? "icon-btn" : "icon-btn-disable"
              }`}
              onClick={() => window.open(project.web_link, "_blank")}
            >
              <Icon path={mdiWeb} className="back-icon" />
            </button>
          </div>
        </div>
      </div>
      <div className="right-view">
        <div
          className={`${
            project.orientation === "landscape"
              ? "current-image-container-landscape"
              : "current-image-container-portrait"
          }`}
        >
          {!currentImage ? (
            <div
              className="skeleton-loader"
              style={{ height: "350px", width: "800px" }}
            ></div> // Adjust width and height
          ) : (
            <Image
              src={currentImage}
              alt={"Project Image"}
              className={`${
                project.orientation === "landscape"
                  ? "current-image-landscape"
                  : "current-image-portrait"
              }`}
              onError={(e) => (e.target.style.display = "none")}
            />
          )}
        </div>
        <div
          className={`${
            project.orientation === "landscape"
              ? "other-image-container-landscape"
              : "other-image-container-portrait"
          }`}
        >
          {!imageLoaded ? (
            <div
              className="skeleton-loader"
              style={{ height: "100px", width: "200px" }}
            ></div> // Adjust width and height
          ) : (
            project?.images?.map((url, index) => (
              <Image
                key={index}
                src={url}
                alt={`Project Image ${index}`}
                className={`${
                  project.orientation === "landscape"
                    ? "other-image-landscape"
                    : "other-image-portrait"
                }`}
                onError={(e) => (e.target.style.display = "none")}
                onClick={() => {
                  setCurrentImage(url);
                }}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Project_Detail;
